import { reactive, ref, computed, onMounted, onBeforeUnmount, watch } from "vue"
import { useDisplay, useGoTo } from "vuetify"

import { eventBus } from "@/plugins/eventBus.js"
import { getRouterState } from "@/router"

export const usePageScroll = () => {
  const scrollPageInfo = reactive({
    lastScrollTop: 0,
    scrollDir: null
  })

  const isScrollDown = computed(() => scrollPageInfo.scrollDir === "down")

  const routerState = reactive(getRouterState())

  const isMobile = ref(false)

  watch(
    () => routerState.previous,
    () => (scrollPageInfo.scrollDir = null)
  )

  const handleScroll = () => {
    const documentElement = document.documentElement
    const scrollTop = window.pageYOffset || documentElement.scrollTop
    const offset = scrollTop + window.innerHeight
    const height = documentElement.offsetHeight

    //Bottom reached (more or less), prevent bouncing behaviour for mobile browsers
    if (isMobile.value && offset >= height - 10) {
      return
    }

    scrollPageInfo.scrollDir = scrollTop > scrollPageInfo.lastScrollTop ? "down" : "up"
    scrollPageInfo.lastScrollTop = Math.max(0, scrollTop)
  }

  const goTo = useGoTo()

  onMounted(() => {
    const { mobile } = useDisplay()
    isMobile.value = mobile.value

    eventBus.$on("window-scroll", handleScroll)
  })
  onBeforeUnmount(() => eventBus.$off("window-scroll", handleScroll))

  return {
    scrollPageInfo,
    isScrollDown,
    goTo
  }
}
